<template>
  <v-card-actions :class="['donation-flow__buttons', extraClass]">
    <div v-if="$slots.prepend" class="donation-flow__buttons-prepend">
      <slot name="prepend" />
    </div>
    <div class="spacer" />
    <v-btn
      v-if="showPrevious"
      :id="previousId || undefined"
      variant="outlined"
      color="primary"
      :data-cy="previousDataCy"
      :aria-label="previousAriaLabel || t('aria.label.previous')"
      :disabled="previousDisabled"
      @click="emit('previousStep')"
    >
      {{ previousLabel || t('generic.labels.prev') }}
    </v-btn>
    <v-btn
      v-if="showNext"
      :id="nextId || undefined"
      class="donation-flow__next-btn"
      variant="elevated"
      color="primary"
      :data-cy="nextDataCy"
      :aria-label="nextAriaLabel || t('aria.label.next')"
      :disabled="nextDisabled"
      :loading="nextLoading"
      @click="emit('nextStep')"
    >
      {{ nextLabel || t('generic.labels.next') }}
    </v-btn>
  </v-card-actions>
</template>

<script setup lang="ts">
import { useLabel } from '@/composables/useLabel';

const { t } = useLabel();

withDefaults(
  defineProps<{
    showPrevious?: boolean;
    showNext?: boolean;
    previousLabel?: string;
    nextLabel?: string;
    previousDataCy?: string;
    nextDataCy?: string;
    previousAriaLabel?: string;
    nextAriaLabel?: string;
    previousId?: string;
    nextId?: string;
    previousDisabled?: boolean;
    nextDisabled?: boolean;
    nextLoading?: boolean;
    extraClass?: string;
  }>(),
  {
    showPrevious: true,
    showNext: true,
    previousDataCy: 'previous-btn',
    nextDataCy: 'next-btn',
    extraClass: '',
  }
);

const emit = defineEmits<{
  previousStep: [];
  nextStep: [];
}>();
</script>

<style scoped>
.donation-flow__buttons {
  display: flex;
}

.donation-flow__buttons .spacer {
  flex: 1 1 auto;
}

@media (min-width: 601px) {
  .donation-flow__buttons :deep(.donation-flow__next-btn) {
    width: 200px;
  }
}

@media (max-width: 600px) {
  .donation-flow__buttons {
    flex-direction: column-reverse !important;
    gap: 12px;
  }

  .donation-flow__buttons :deep(.v-btn) {
    width: 100% !important;
  }

  .donation-flow__buttons .spacer {
    display: none !important;
  }

  .donation-flow__buttons-prepend {
    width: 100%;
  }
}
</style>
